import { ResultStatus } from '@dispatch/shared/types';
import { Chip } from '@mui/material';

export const ResourceStatusChip = ({
  isActive,
  isStandby,
  status,
}: {
  isActive: boolean;
  isStandby: boolean;
  status: ResultStatus;
}) => {
  if (status !== 'loading') {
    if (!isActive) {
      return (
        <Chip
          data-testid="drawer-active"
          label={'Inactive'}
          sx={{
            minWidth: '5em',
            fontSize: '.85em',
            color: '#FFFFFF',
            backgroundColor: '#F44336',
          }}
        />
      );
    }
    if (isStandby) {
      return (
        <Chip
          data-testid="drawer-active"
          label={'Standby'}
          sx={{
            minWidth: '5em',
            fontSize: '.85em',
            color: '#FFFFFF',
            backgroundColor: '#FFA726',
          }}
        />
      );
    } else {
      return (
        <Chip
          data-testid="drawer-active"
          label={'Active'}
          sx={{
            minWidth: '5em',
            fontSize: '.85em',
            color: '#FFFFFF',
            backgroundColor: '#4CAF50',
          }}
        />
      );
    }
  }
  return null;
};
